// eslint-disable-next-line import/no-anonymous-default-export
export default {
  coeMyWork: {
    entityTypeName: "我发起的",
    name: "工单名称",
    introduction: "发起并管理我的自动化需求",
  },
};
